export default {
  pagingRow: '{start} - {stop} iš {length}',
  all: 'Visi',
  noData: 'Nieko nerasta',
  rowsPerPage: 'Rezultatai puslapyje:',
  soupsCount: 'Sriubų kiekis:',
  mainsCount: 'Pagr. patiekalų kiekis:',
};
